import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaChevronRight } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  const quickLinks = [
    ["Home", "/"],
    ["About Us", "/about"],
    ["Our Businesses", "/services"],
    ["Gallery", "/gallery"],
    ["Admin Portal", "/admin"]
  ];

  return (
    <footer className="sg-footer">
      {/* ========== MAIN FOOTER ========== */}
      <div className="sg-footer-main">
        <div className="container sg-footer-grid">
          
          {/* Left: About & Identity */}
          <div className="sg-footer-about">
            <Link to="/" className="sg-footer-logo">
              <img src="/Sarwa Logo.png" alt="Sarwa Group" />
            </Link>

            <p className="sg-footer-desc">
              Sarwa Group is a diversified business conglomerate operating across
              multiple industries with a legacy built on transparency, ethical values, 
              and sustainable growth.
            </p>

            <em className="sg-footer-tagline">"Where Trust Meets Transparency"</em>
          </div>

          {/* Center: Quick Links */}
          <div className="sg-footer-col-links">
            <h4 className="sg-footer-title">Quick Links</h4>
            <div className="sg-footer-title-line"></div>
            <ul className="sg-footer-links-list">
              {quickLinks.map(([name, path]) => (
                <li key={path}>
                  <Link to={path} className="sg-footer-link-item">
                    <FaChevronRight className="sg-link-chevron" />
                    <span>{name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: HQ Contact */}
          <div className="sg-footer-col-contact">
            <h4 className="sg-footer-title">Get In Touch</h4>
            <div className="sg-footer-title-line"></div>
            
            <a href="mailto:connectsarwagroup@gmail.com" className="sg-footer-email">
              <span className="sg-email-icon-box">
                <FaEnvelope />
              </span>
              <span>connectsarwagroup@gmail.com</span>
            </a>
          </div>

        </div>
      </div>

      {/* ========== BOTTOM BAR ========== */}
      <div className="sg-footer-bottom">
        <div className="container sg-footer-bottom-inner">
          <p className="sg-footer-copyright">
            © {year} <span>Sarwa Group</span>. All rights reserved.
          </p>

          <p className="sg-footer-powered">
            Powered by{" "}
            <a
              href="https://www.yashvitech.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Yashvi Tech IT Solution
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;